/* Meller — barra flutuante Add to cart na PDP. Aparece quando o buy box sai da tela
   (rolando pra baixo) e some perto do rodapé. Clica no botão real de add to cart. */
(function () {
  if (window.__mlrSatc) return; window.__mlrSatc = true;

  function realAddButton() {
    // botão principal do buy box (o nativo sticky do tema está desativado)
    return document.querySelector('.buy-buttons-block .add-to-cart-button')
      || document.querySelector('.product-information .add-to-cart-button:not(.sticky-add-to-cart__button)')
      || document.querySelector('[id*="ProductSubmitButton"]');
  }

  function init() {
    var bar = document.querySelector('[data-mlr-satc]');
    if (!bar) return;
    var realBtn = realAddButton();
    var footer = document.querySelector('footer') || document.querySelector('[class*="footer-group"]');
    var addBtn = bar.querySelector('[data-mlr-satc-add]');

    if (addBtn) {
      addBtn.addEventListener('click', function (e) {
        e.preventDefault();
        var b = realAddButton();
        if (b) b.click();
      });
    }

    function update() {
      var b = realBtn || realAddButton();
      if (!b) { bar.classList.remove('is-visible'); return; }
      var r = b.getBoundingClientRect();
      var pastBuyBox = r.bottom < 0;                 // buy box rolou pra cima (fora da tela)
      var footerIn = footer ? (footer.getBoundingClientRect().top < window.innerHeight - 40) : false;
      var show = pastBuyBox && !footerIn;
      bar.classList.toggle('is-visible', show);
      bar.setAttribute('aria-hidden', show ? 'false' : 'true');
    }

    var ticking = false;
    function onScroll() {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(function () { update(); ticking = false; });
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll);
    window.addEventListener('load', update);
    update();
  }

  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', init);
})();
